import Vue from 'vue'
import Router from 'vue-router'
import i18n from './i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('./views/quotes/QuotesLayout.vue'),
      children: [
        {
          path: '',
          name: 'quotes-list',
          meta: {
            title: 'QUOTES_LIST.TITLE'
          },
          component: () => import('./views/quotes/list/QuotesList.vue')
        },
        {
          path: ':id',
          name: 'quotes-detail',
          meta: {
            title: 'QUOTES_DETAIL.TITLE'
          },
          component: () => import('./views/quotes/detail/QuotesDetail.vue')
        }
      ]
    },
    {
      path: '**',
      redirect: { name: 'quotes' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const title = i18n.t(to.meta.title)
  const appCompany = i18n.t('APP.COMPANY')
  
  document.title = `${title} - ${appCompany}`
  
  next()
})

export default router
